// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settingsBlock__qvDGz {
  height: 100%;
  display: grid;
  grid-template-columns: 2fr 3fr;
  background-color: var(--tables-secondary-row-sub-title-surface);
  box-shadow: var(--basic-box-shadow);
}

.blockHead__b9PrU {
  padding: 10.5px 20px;
  border-bottom: 1px solid var(--tables-title-stroke);
  background: var(--tables-title-surface);
}

.blockTitle__fYQ5f {
  font-size: 11px;
  line-height: 14px;
  color: var(--tables-title-text);
  text-transform: uppercase;
  padding-top: 5px;
  padding-bottom: 5px;
  display: flex;
  align-items: center;
  column-gap: 3px;
}
@media (max-width: 1000px) {
  .blockTitle__fYQ5f {
    grid-column: 1/4;
  }
}

.sortIcon__mWgJ7 {
  cursor: pointer;
  outline: none;
  min-width: 6px;
}
.sortIcon__mWgJ7 path {
  fill: var(--tables-title-icon);
}

.facilityBlock__N2vgr {
  background-color: var(--tables-primary-row-surface-default);
  border-right: 1px solid var(--tables-title-stroke);
}

.facilityBlockHead__b8yBr {
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 25px;
}
@media (max-width: 1000px) {
  .facilityBlockHead__b8yBr {
    min-height: 74px;
  }
}

.facilityItem__P57c7 {
  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
  color: var(--tables-primary-row-text-main);
  text-transform: uppercase;
  padding: 15px 20px;
  display: flex;
  align-items: center;
  column-gap: 25px;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
}
.facilityItem__P57c7:hover {
  background-color: var(--tables-primary-row-surface-selected);
}

.notificationsBlockBody__i1OGf {
  background-color: var(--tables-secondary-row-sub-title-surface);
}

.notificationsBlockBodyShort__bg3xT {
  height: 275px;
  overflow-y: auto;
}

.notificationsBlockHead__ee6Ay {
  display: grid;
  grid-template-columns: auto repeat(3, 72px);
  column-gap: 20px;
}
@media (max-width: 1000px) {
  .notificationsBlockHead__ee6Ay {
    row-gap: 10px;
    grid-template-columns: repeat(3, 100px);
    grid-template-rows: auto 1fr;
  }
}

.emptyBlockWrapper__PSKPP {
  max-height: 450px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--tables-secondary-row-sub-title-surface);
}

.emptyBlockText__UxpVi {
  font-size: 11px;
  font-weight: 500;
  line-height: 14px;
  color: var(--tables-primary-row-text-additional);
}

.checkboxHigh__rzI1K {
  border: 1px solid var(--labels-outline-stroke-text-high);
}
.checkboxHigh__rzI1K div {
  background-color: var(--labels-outline-stroke-text-high);
}
.checkboxHigh__rzI1K ~ p {
  text-transform: uppercase;
}

.checkboxStandard__GcGzJ {
  text-transform: uppercase;
  border: 1px solid var(--labels-outline-stroke-text-standard);
}
.checkboxStandard__GcGzJ div {
  background-color: var(--labels-outline-stroke-text-standard);
}
.checkboxStandard__GcGzJ ~ p {
  text-transform: uppercase;
}

.checkboxCritical__HeF9a {
  text-transform: uppercase;
  border: 1px solid var(--labels-outline-stroke-text-critical);
}
.checkboxCritical__HeF9a div {
  background-color: var(--labels-outline-stroke-text-critical);
}
.checkboxCritical__HeF9a ~ p {
  text-transform: uppercase;
}

.notificationsRow__Oytwt {
  padding: 15px 20px;
  display: grid;
  grid-template-columns: auto repeat(3, 72px);
  column-gap: 20px;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
}
@media (max-width: 1000px) {
  .notificationsRow__Oytwt {
    row-gap: 10px;
    grid-template-columns: repeat(3, 100px);
    grid-template-rows: auto 1fr;
  }
}

.notificationsRowName__fGXMZ {
  font-size: 12px;
  line-height: 18px;
  color: var(--tables-primary-row-text-main);
}
@media (max-width: 1000px) {
  .notificationsRowName__fGXMZ {
    grid-column: 1/4;
  }
}

.checkboxSkeleton___NvXM {
  width: 24px;
  height: 24px;
}

.textSkeleton__eAFvi {
  width: 100%;
  height: 16px;
}

.mainBodyText__ChZQ3 {
  margin-top: 5px;
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./../src/components/common/EmailNotificationsProfile/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,aAAA;EACA,8BAAA;EACA,+DAAA;EACA,mCAAA;AAzEF;;AA4EA;EACE,oBAAA;EACA,mDAAA;EACA,uCAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAzEF;AA2EE;EAXF;IAYI,gBAAA;EAxEF;AACF;;AA2EA;EACE,eAAA;EACA,aAAA;EACA,cAAA;AAxEF;AA0EE;EACE,8BAAA;AAxEJ;;AA4EA;EACE,2DAAA;EACA,kDAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AAzEF;AA2EE;EANF;IAOI,gBAAA;EAxEF;AACF;;AA2EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,0CAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,yDAAA;AAxEF;AA0EE;EACE,4DAAA;AAxEJ;;AA2EA;EACE,+DAAA;AAxEF;;AA2EA;EACE,aAAA;EACA,gBAAA;AAxEF;;AA2EA;EACE,aAAA;EACA,2CAAA;EACA,gBAAA;AAxEF;AA0EE;EALF;IAMI,aAAA;IACA,uCAAA;IACA,4BAAA;EAvEF;AACF;;AA0EA;EACE,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,+DAAA;AAvEF;;AA0EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gDAAA;AAvEF;;AA0EA;EACE,wDAAA;AAvEF;AAyEE;EACE,wDAAA;AAvEJ;AA0EE;EACE,yBAAA;AAxEJ;;AA4EA;EACE,yBAAA;EACA,4DAAA;AAzEF;AA2EE;EACE,4DAAA;AAzEJ;AA4EE;EACE,yBAAA;AA1EJ;;AA8EA;EACE,yBAAA;EACA,4DAAA;AA3EF;AA6EE;EACE,4DAAA;AA3EJ;AA8EE;EACE,yBAAA;AA5EJ;;AAgFA;EACE,kBAAA;EACA,aAAA;EACA,2CAAA;EACA,gBAAA;EACA,yDAAA;AA7EF;AA+EE;EAPF;IAQI,aAAA;IACA,uCAAA;IACA,4BAAA;EA5EF;AACF;;AA+EA;EACE,eAAA;EACA,iBAAA;EACA,0CAAA;AA5EF;AA6EE;EAJF;IAKI,gBAAA;EA1EF;AACF;;AA6EA;EACE,WAAA;EACA,YAAA;AA1EF;;AA6EA;EACE,WAAA;EACA,YAAA;AA1EF;;AA6EA;EACE,eAAA;EACA,mBAAA;AA1EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.settingsBlock {\n  height: 100%;\n  display: grid;\n  grid-template-columns: 2fr 3fr;\n  background-color: var(--tables-secondary-row-sub-title-surface);\n  box-shadow: var(--basic-box-shadow);\n}\n\n.blockHead {\n  padding: 10.5px 20px;\n  border-bottom: 1px solid var(--tables-title-stroke);\n  background: var(--tables-title-surface);\n}\n\n.blockTitle {\n  font-size: 11px;\n  line-height: 14px;\n  color: var(--tables-title-text);\n  text-transform: uppercase;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  display: flex;\n  align-items: center;\n  column-gap: 3px;\n\n  @media (max-width: 1000px) {\n    grid-column: 1/4;\n  }\n}\n\n.sortIcon {\n  cursor: pointer;\n  outline: none;\n  min-width: 6px;\n\n  path {\n    fill: var(--tables-title-icon);\n  }\n}\n\n.facilityBlock {\n  background-color: var(--tables-primary-row-surface-default);\n  border-right: 1px solid var(--tables-title-stroke);\n}\n\n.facilityBlockHead {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  column-gap: 25px;\n\n  @media (max-width: 1000px) {\n    min-height: 74px;\n  }\n}\n\n.facilityItem {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 12px;\n  color: var(--tables-primary-row-text-main);\n  text-transform: uppercase;\n  padding: 15px 20px;\n  display: flex;\n  align-items: center;\n  column-gap: 25px;\n  border-bottom: 1px solid var(--tables-primary-row-stroke);\n\n  &:hover {\n    background-color: var(--tables-primary-row-surface-selected);\n  }\n}\n.notificationsBlockBody {\n  background-color: var(--tables-secondary-row-sub-title-surface);\n}\n\n.notificationsBlockBodyShort {\n  height: 275px;\n  overflow-y: auto;\n}\n\n.notificationsBlockHead {\n  display: grid;\n  grid-template-columns: auto repeat(3, 72px);\n  column-gap: 20px;\n\n  @media (max-width: 1000px) {\n    row-gap: 10px;\n    grid-template-columns: repeat(3, 100px);\n    grid-template-rows: auto 1fr;\n  }\n}\n\n.emptyBlockWrapper {\n  max-height: 450px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--tables-secondary-row-sub-title-surface);\n}\n\n.emptyBlockText {\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 14px;\n  color: var(--tables-primary-row-text-additional);\n}\n\n.checkboxHigh {\n  border: 1px solid var(--labels-outline-stroke-text-high);\n\n  div {\n    background-color: var(--labels-outline-stroke-text-high);\n  }\n\n  & ~ p {\n    text-transform: uppercase;\n  }\n}\n\n.checkboxStandard {\n  text-transform: uppercase;\n  border: 1px solid var(--labels-outline-stroke-text-standard);\n\n  div {\n    background-color: var(--labels-outline-stroke-text-standard);\n  }\n\n  & ~ p {\n    text-transform: uppercase;\n  }\n}\n\n.checkboxCritical {\n  text-transform: uppercase;\n  border: 1px solid var(--labels-outline-stroke-text-critical);\n\n  div {\n    background-color: var(--labels-outline-stroke-text-critical);\n  }\n\n  & ~ p {\n    text-transform: uppercase;\n  }\n}\n\n.notificationsRow {\n  padding: 15px 20px;\n  display: grid;\n  grid-template-columns: auto repeat(3, 72px);\n  column-gap: 20px;\n  border-bottom: 1px solid var(--tables-primary-row-stroke);\n\n  @media (max-width: 1000px) {\n    row-gap: 10px;\n    grid-template-columns: repeat(3, 100px);\n    grid-template-rows: auto 1fr;\n  }\n}\n\n.notificationsRowName {\n  font-size: 12px;\n  line-height: 18px;\n  color: var(--tables-primary-row-text-main);\n  @media (max-width: 1000px) {\n    grid-column: 1/4;\n  }\n}\n\n.checkboxSkeleton {\n  width: 24px;\n  height: 24px;\n}\n\n.textSkeleton {\n  width: 100%;\n  height: 16px;\n}\n\n.mainBodyText {\n  margin-top: 5px;\n  margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"settingsBlock": `settingsBlock__qvDGz`,
	"blockHead": `blockHead__b9PrU`,
	"blockTitle": `blockTitle__fYQ5f`,
	"sortIcon": `sortIcon__mWgJ7`,
	"facilityBlock": `facilityBlock__N2vgr`,
	"facilityBlockHead": `facilityBlockHead__b8yBr`,
	"facilityItem": `facilityItem__P57c7`,
	"notificationsBlockBody": `notificationsBlockBody__i1OGf`,
	"notificationsBlockBodyShort": `notificationsBlockBodyShort__bg3xT`,
	"notificationsBlockHead": `notificationsBlockHead__ee6Ay`,
	"emptyBlockWrapper": `emptyBlockWrapper__PSKPP`,
	"emptyBlockText": `emptyBlockText__UxpVi`,
	"checkboxHigh": `checkboxHigh__rzI1K`,
	"checkboxStandard": `checkboxStandard__GcGzJ`,
	"checkboxCritical": `checkboxCritical__HeF9a`,
	"notificationsRow": `notificationsRow__Oytwt`,
	"notificationsRowName": `notificationsRowName__fGXMZ`,
	"checkboxSkeleton": `checkboxSkeleton___NvXM`,
	"textSkeleton": `textSkeleton__eAFvi`,
	"mainBodyText": `mainBodyText__ChZQ3`
};
module.exports = ___CSS_LOADER_EXPORT___;
